"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _TextEffect2 = _interopRequireDefault(require("./TextEffect"));

var _Color = _interopRequireDefault(require("../../../models/Color"));

var _creative = require("../../../constants/creative");

var _text = require("../../../constants/text");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_OUTER_GLOW_VALUES = _text.DEFAULT_TEXT_EFFECTS_OBJECTS[_text.TEXT_EFFECTS.OUTER_GLOW];

var OuterGlowTextEffect = /*#__PURE__*/function (_TextEffect) {
  (0, _inherits2["default"])(OuterGlowTextEffect, _TextEffect);

  var _super = _createSuper(OuterGlowTextEffect);

  function OuterGlowTextEffect() {
    (0, _classCallCheck2["default"])(this, OuterGlowTextEffect);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(OuterGlowTextEffect, null, [{
    key: "apply",
    value: function apply(finalContext, effectContext, frameNumber, contentFrameData, layerTransformData) {
      (0, _get2["default"])((0, _getPrototypeOf2["default"])(OuterGlowTextEffect), "apply", this).call(this, finalContext, effectContext, frameNumber, contentFrameData, layerTransformData);
      var textRenderProperties = contentFrameData.textRenderProperties;
      var shadowColor = textRenderProperties.textEffect.get('color') || DEFAULT_OUTER_GLOW_VALUES.color;
      var opacity = textRenderProperties.textEffect.get('opacity') / 100;

      if (opacity <= 0) {
        this.drawTextLines(finalContext, contentFrameData);
        return;
      }

      var rgbaColor = _Color["default"].getColorFromHexColor(shadowColor, opacity);

      finalContext.shadowColor = rgbaColor.toString();
      finalContext.shadowOffsetX = 0;
      finalContext.shadowOffsetY = 0;
      finalContext.shadowBlur = textRenderProperties.textEffect.get('size') * 2.5;
      this.drawTextLines(finalContext, contentFrameData, 3); // repeat for glow intensity

      finalContext.shadowColor = _creative.TRANSPARENT_FILL_COLOR; // remove shadow !
    }
  }]);
  return OuterGlowTextEffect;
}(_TextEffect2["default"]);

exports["default"] = OuterGlowTextEffect;